import React, { Component } from 'react';
import './newHeader.scss';
import { Dropdown, Menu } from 'antd';
class DownloadApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      docId: '', // ! 上传文档的Id
      isShowDialog: false,
    };
  }

  downloadWindowsApp = () => {
    _hmt.push(['_trackEvent', '点击量_Windows版', '1']);
    window.open('https://file.foxitreader.cn/file/Channel/edit/ybjtop_FoxitPDFP.exe');
  };
  downloadMacApp = () => {
    _hmt.push(['_trackEvent', '点击量_Mac版', '1']);
    window.open('https://file.foxitreader.cn/file/Channel/macedit/foxit_CNsetup.pkg');
  };

  render() {
    // const { isShowDialog } = this.state
    const menus2 = (
      <Menu className="fw_logo-menu">
        <Menu.Item onClick={this.downloadWindowsApp} data-agl-cvt="6">
          <span>
            <i className="downloadApp-icon-btn cursor-pointer downloadApp-windows"></i>Windows版
          </span>
        </Menu.Item>
        <Menu.Item onClick={this.downloadMacApp} data-agl-cvt="6">
          <span>
            <i className="downloadApp-icon-btn cursor-pointer downloadApp-mac"></i>Mac版
          </span>
        </Menu.Item>
      </Menu>
    );
    return (
      <div className="downloadApp-btn-box-main">
        <Dropdown overlay={menus2} placement="bottomLeft" trigger={['hover']}>
          <span className="downloadApp-btn-box">
            <i className="icon-btn cursor-pointer downloadApp-btn"></i>
            <span>下载客户端</span>
          </span>
        </Dropdown>
      </div>
    );
  }
}
export default DownloadApp;
